import { useAppDispatch } from "@/shared/lib/redux"
import {
    openFoundationAccrualModal as openFoundationAccrualModalAction,
    closeFoundationAccrualModal as closeFoundationAccrualModalAction
} from '../../model'

interface FoundationAccrualProgram {
    id: string
    name: string
}

export const useFoundationAccrualModal = () => {
    const dispatch = useAppDispatch()

    const openFoundationAccrualModal = (onSuccess?: () => void, program?: FoundationAccrualProgram) => {
        dispatch(openFoundationAccrualModalAction({ onSuccess, program }))
    }

    const closeFoundationAccrualModal = () => {
        dispatch(closeFoundationAccrualModalAction())
    }

    return {
        openFoundationAccrualModal,
        closeFoundationAccrualModal
    }
}
